import { Locale } from 'modules/i18n';

export const buttonsTranslation = {
  [Locale.en]: {
    cancelButton: 'Cancel',
    signInButton: 'Sign in with another account',
  },
};
